import React from 'react';
import { Link } from 'react-router-dom';
import './SubscriptionCancel.css';

const SubscriptionCancel: React.FC = () => {
  return (
    <div className="subscription-cancel-page">
      <div className="cancel-container">
        <div className="cancel-icon">⚠️</div>
        <h1>Subscription Cancelled</h1>
        <p className="cancel-message">
          Your subscription payment was cancelled. No charges have been made to your account.
        </p>

        <div className="cancel-info">
          <h3>What happened?</h3>
          <p>
            You cancelled the payment process or closed the payment window before completing the transaction.
            Your account remains on the current plan.
          </p>
        </div>

        <div className="cancel-actions">
          <Link to="/subscription" className="btn btn-primary">
            Try Again
          </Link>
          <Link to="/dashboard" className="btn btn-secondary">
            Return to Dashboard
          </Link>
        </div>

        <div className="cancel-help">
          <p>
            Having trouble with payment? <Link to="/settings">Contact support</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
